import { bigQuery } from '@fiverr-private/obs';
import { ACTION_TYPES, GROUPES, SOURCES, SUB_GROUPES } from '../constants';
import { getMarketplaceIntegrationBqPayload } from '../utils';

const trackLogoVariationFromGalleryClick =
    ({ projectsMap, briefId }) =>
    (cardDetails) => {
        const project = projectsMap[cardDetails.projectId] || {};

        const payload = {
            action: { type: ACTION_TYPES.CLICK },
            type: 'clicked_on_variation_from_logo_card_gallery',
            gig_impression: [{ type: project.engineType }],
            group: GROUPES.USER_ACTION,
            sub_group: SUB_GROUPES.WEBSITE_ACTION,
            source: SOURCES.SUBCATEGORY,
            makers_project: {
                id: cardDetails.projectId,
                brief: { id: briefId },
                variation: { id: cardDetails.variationId },
            },
            item_context: {
                position: cardDetails.logoPosition,
                variation_position: cardDetails.variationPosition,
            },
        };
        bigQuery.send(getMarketplaceIntegrationBqPayload(payload, cardDetails));
    };

export default trackLogoVariationFromGalleryClick;
